import PriceFactory from '../factories/PriceFactory';
import FormatPriceViewModel from '../view-models/FormatPriceViewModel';

export default class PriceFacade {
    private static instance: PriceFacade;

    private constructor() {}

    public static getInstance(): PriceFacade {
        if (!this.instance) {
            this.instance = new PriceFacade();
        }

        return this.instance;
    }

    public format(price: string | number, defaultText?: string) {
        const useCase = PriceFactory.makeFormatUseCase();
        const model = new FormatPriceViewModel(price);
        model.defaultText = defaultText ?? '';

        return useCase.invoke(model).data;
    }
}
